import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import Arrow from '~/static/images/bundles-landing/placeholder.svg';

import { Col as ColCommon, Row as RowCommon } from '~/src/features/center/common/styled';

export const Col = ColCommon;

export const ColPhoneWrap = styled(Col)`

    @media (max-width: ${breakPoints.mobile}) {
        padding-left: 0;
    }
`;

export const ColCityWrap = styled(ColCommon)`
    max-width: 51%;
    flex-basis: 51%;
    padding-left: 35px;

    @media (max-width: ${breakPoints.desktop}) {
        padding-left: 60px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        padding-left: 35px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        padding-left: 45px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 100%;
        flex-basis: 100%;
        padding-left: 0;
    }
`;

export const ColCity = styled(ColCommon)`

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 85%;
    }
`;

export const CitySelect = styled.span`
    ${FONTS.H4};
    color: ${COLORS.black};
    position: relative;
    cursor: pointer;
    margin-left: 75px;
    z-index: 10;

    &:before {
        content: '';
        position:absolute;
        left: -20px;
        top: 7px;
        width: 14px;
        height: 14px;
        background-image: url(${Arrow});
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        margin-left: 109px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        margin-top: 8px;
        margin-left: 0;
        display: block;
    }
`;

export const WrapperPhone = styled.div`
    justify-content: flex-end;

    @media (max-width: ${breakPoints.mobile}) {
        justify-content: left;
    }
`;

export const Phone = styled.a`
    position: relative;
    color: ${COLORS.black};
    ${FONTS.H4};
    cursor: pointer;
    display: block;
    text-align: right;

    @media (min-width: ${breakPoints.tablet}) {

        &:after {
            content: '';
            position: absolute;
            left: -24px;
            right: 0;
            top: -10px;
            bottom: 0;
            height: 28px;
            width: 200px;
            background-color: ${COLORS.white};
            border-radius: 24px;
            padding: 10px 24px 7px 24px;
            z-index: -1;
        }
    }

    @media (max-width: ${breakPoints.mobile}) {
        text-align: left;
        ${FONTS.XS};
    }
`;

export const Logo = styled.img`
    position:relative;
    z-index: 10;
`;

export const Row = RowCommon;

export const RowBlock = styled(FlexBoxRow)`
    margin-top: 20px;
    align-items: center;
`;
